<div class="btn-group d-flex flex-wrap position-relative" role="group" [ngClass]="['radios-'+color, autoFit?'autofit':'']"
  [class]="customClass">
  @for (option of options; track option) {
    <label class="btn text-nowrap d-flex align-items-center"
      [ngClass]="['btn-outline-'+color, customOptionClass]">
      <input type="radio" name="radio-group_{{uuid}}" class="me-1" [value]="option.value" [(ngModel)]="model"
        [name]="name" (change)="onRadioChange(option.value)" [disabled]="disabled  || option.disabled">
        <span>{{ option.text | translate}}</span>
      </label>
    }
    <input type="text" class="size-0 position-absolute bottom-0" tabindex="-1" [required]="required && isEmpty()"
      [name]="name+'_required'">
    </div>
